import axios from "axios";
import {
  AutomationRuleDraft,
  AutomationRuleListResponse,
  AutomationRuleTestResult,
  RuleListFilter,
  WhatsAppAutomationRule,
} from "../models/automationRule.model";

const BASE_URL =
  process.env.REACT_APP_PYTHON_BACKEND_URL || "http://localhost:8000";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export async function getAutomationRules(
  businessId: string,
  params?: {
    status?: RuleListFilter;
    search?: string;
  },
): Promise<AutomationRuleListResponse> {
  const response = await api.get(
    `/businesses/${businessId}/automation-rules`,
    { params },
  );
  return response.data;
}

export async function createAutomationRule(
  businessId: string,
  payload: AutomationRuleDraft,
): Promise<WhatsAppAutomationRule> {
  const response = await api.post(
    `/businesses/${businessId}/automation-rules`,
    payload,
  );
  return response.data;
}

export async function updateAutomationRule(
  businessId: string,
  ruleId: string,
  payload: AutomationRuleDraft,
): Promise<WhatsAppAutomationRule> {
  const response = await api.put(
    `/businesses/${businessId}/automation-rules/${ruleId}`,
    payload,
  );
  return response.data;
}

export async function deleteAutomationRule(
  businessId: string,
  ruleId: string,
): Promise<void> {
  await api.delete(`/businesses/${businessId}/automation-rules/${ruleId}`);
}

export async function testAutomationRule(
  businessId: string,
  message: string,
): Promise<AutomationRuleTestResult> {
  const response = await api.post(
    `/businesses/${businessId}/automation-rules/test`,
    { message },
  );
  return response.data;
}
